import React, { useEffect, useMemo, useState } from "react";
import { FaHeart } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const FavoriteCard = ({ avatar, isFavorite, onToggleFavorite, contributorName, bodyPart }) => {
  const navigate = useNavigate();
  const fallbackImage = useMemo(
    () =>
      `data:image/svg+xml;utf8,${encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="260" viewBox="0 0 320 260">
          <rect width="320" height="260" fill="#1c1c1e"/>
          <rect x="18" y="18" width="284" height="224" rx="10" fill="#2a2a2d" stroke="#ceb46a" stroke-width="2"/>
          <text x="160" y="122" fill="#ceb46a" font-family="Arial, sans-serif" font-size="18" font-weight="700" text-anchor="middle">Image unavailable</text>
          <text x="160" y="150" fill="#b8c0d4" font-family="Arial, sans-serif" font-size="13" text-anchor="middle">Media needs to be restored</text>
        </svg>`
      )}`,
    []
  );
  const [imageSrc, setImageSrc] = useState(avatar || fallbackImage);

  useEffect(() => {
    setImageSrc(avatar || fallbackImage);
  }, [avatar, fallbackImage]);

  return (
    <div className="relative overflow-hidden rounded-xl shadow-md group">
      <img
        src={imageSrc}
        alt={contributorName ? `${contributorName} favorite` : "Favorite"}
        className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
        referrerPolicy="no-referrer"
        onError={() => setImageSrc(fallbackImage)}
      />

      {(contributorName || bodyPart) && (
        <div className="absolute bottom-0 left-0 right-0 bg-black/75 px-3 py-2">
          {contributorName && (
            <p className="truncate text-sm font-semibold text-white">{contributorName}</p>
          )}
          {bodyPart && (
            <p className="truncate text-xs text-[#ceb46a]">{bodyPart}</p>
          )}
        </div>
      )}

      {/* Active button - now always shown */}
      <button
        onClick={() => navigate('/contests')}
        className="absolute top-2 left-2 bg-green-600 text-white text-sm px-3 py-1 rounded-full border border-black shadow-lg z-10 transition-transform hover:scale-105"
      >
        Active
      </button>

      {/* Heart Favorite Toggle */}
      <button
        onClick={onToggleFavorite}
        className="absolute top-2 right-2 text-white text-xl z-10"
        aria-label="Toggle Favorite"
      >
        <FaHeart
          className={`transition-transform duration-300 ${
            isFavorite ? "text-red-500 scale-110" : "text-gray-300"
          }`}
        />
      </button>
    </div>
  );
};

export default FavoriteCard;
